/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    AUTOREPORT_ID_GET_META_FAILURE,
    AUTOREPORT_ID_GET_META_START,
    AUTOREPORT_ID_GET_META_SUCCESS,
    AUTOREPORT_ID_GET_TAB_META_FAILURE,
    AUTOREPORT_ID_GET_TAB_META_START,
    AUTOREPORT_ID_GET_TAB_META_SUCCESS,
    AUTOREPORT_ID_LOAD_FORMAT_META, AUTOREPORT_ID_LOAD_SCHEDULE_META,
    initialAutoReportState,
} from './constants';
import {
    EPageAutoReportIdType,
    IAutoReportIdFormatMeta,
    IAutoReportIdScheduleMeta,
    TAutoReportIdActions,
} from './types';


export interface IAutoReportIdReducer {
    id: string;
    isError: boolean;
    isLoading: boolean;
    name: string;
    type: EPageAutoReportIdType;
    /* AUTOREPORT ID FORMAT META */
    formatMeta: IAutoReportIdFormatMeta;
    /* AUTOREPORT ID SCHEDULE PARAMETERS */
    scheduleMeta: IAutoReportIdScheduleMeta;
}

const autoReportIdReducer: Reducer<IAutoReportIdReducer, TAutoReportIdActions> =
    (state = initialAutoReportState, action: TAutoReportIdActions) =>
        produce(state, draft => {
            switch (action.type) {

                /* AUTOREPORT ID META */
                case AUTOREPORT_ID_GET_META_START:
                    draft.id = action.payload.id;
                    draft.isError = false;
                    draft.isLoading = true;
                    break;
                case AUTOREPORT_ID_GET_META_SUCCESS:
                    draft.name = action.payload.name;
                    draft.type = action.payload.type;
                    draft.isLoading = false;
                    break;
                case AUTOREPORT_ID_GET_META_FAILURE:
                    draft.isError = true;
                    draft.isLoading = false;
                    break;

                case AUTOREPORT_ID_GET_TAB_META_START:
                    draft.isError = false;
                    draft.isLoading = true;
                    break;
                case AUTOREPORT_ID_GET_TAB_META_SUCCESS:
                    draft.isLoading = false;
                    break;
                case AUTOREPORT_ID_GET_TAB_META_FAILURE:
                    draft.isLoading = true;
                    break;

                /* AUTOREPORT ID FORMAT */
                case AUTOREPORT_ID_LOAD_FORMAT_META:
                    draft.formatMeta = action.payload;
                    break;

                /* AUTOREPORT ID SCHEDULE PARAMETERS */
                case AUTOREPORT_ID_LOAD_SCHEDULE_META:
                    draft.scheduleMeta = action.payload;
                    break;
            }
        });

export default autoReportIdReducer;
